const LOADER_COMPLETE_EVENT = "app:loader-complete";

let complete = false;

export const markLoaderComplete = () => {
  if (complete) return;
  complete = true;
  window.dispatchEvent(new Event(LOADER_COMPLETE_EVENT));
};

export const isLoaderComplete = () => complete;

export const onLoaderComplete = (callback) => {
  if (complete) {
    callback();
    return () => {};
  }
  const handler = () => callback();
  window.addEventListener(LOADER_COMPLETE_EVENT, handler);
  return () => window.removeEventListener(LOADER_COMPLETE_EVENT, handler);
};
